var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "phone-prefix-select", class: { open: _vm.open } },
    [
      _c("input", {
        ref: "input",
        staticClass: "field-input prefix-input",
        attrs: { type: "text", placeholder: "Search code" },
        domProps: { value: _vm.displayText },
        on: {
          focus: _vm.openDropdown,
          input: _vm.onSearchInput,
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.moveHighlight(1)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.moveHighlight(-1)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.selectHighlighted.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.closeDropdown.apply(null, arguments)
            }
          ]
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "select-arrow" }, [_vm._v("▾")]),
      _vm._v(" "),
      _vm.open
        ? _c(
            "div",
            { staticClass: "prefix-dropdown" },
            [
              _vm._l(_vm.filteredCountryCodes, function(code, index) {
                return _c(
                  "button",
                  {
                    key: code.value + "-" + code.label,
                    staticClass: "prefix-option",
                    class: { highlighted: index === _vm.highlightedIndex },
                    attrs: { type: "button" },
                    on: {
                      mousedown: function($event) {
                        $event.preventDefault()
                        return _vm.selectCode(code)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(code.label) + "\n    ")]
                )
              }),
              _vm._v(" "),
              !_vm.filteredCountryCodes.length
                ? _c("div", { staticClass: "no-results" }, [
                    _vm._v("No results")
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36604cbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36604cbc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhonePrefixSelect.vue
// module id = 420
// module chunks = 0